import { ComponentPropsWithoutRef, forwardRef } from "react";

import { classNames } from "../../utils";

type AnchorButtonProps = Omit<ComponentPropsWithoutRef<"button">, "type"> & {
  color?: "primary" | "red";
};

const AnchorButton = forwardRef<HTMLButtonElement, AnchorButtonProps>(
  ({ children, className, color, disabled, ...props }, ref) => {
    return (
      <>
        {" "}
        <button
          className={classNames(
            "underline",
            color === "red" && "text-red-800 dark:text-red-200",
            color === "primary" && "text-primary-500",
            disabled ? "cursor-default opacity-50" : "cursor-pointer",
            className,
          )}
          disabled={disabled}
          ref={ref}
          type="button"
          {...props}
        >
          {children}
        </button>{" "}
      </>
    );
  },
);

export default AnchorButton;
